import React, { useState, useContext } from 'react';
import styled from 'styled-components';

import { Tabs } from 'antd';

import LeaseHeader from './LeaseHeader';
import { CurrentApplicationContext } from './ApplicationOverview';
import Overview from './lease_overview/Overview';
import LeaseDetails from './lease_overview/LeaseDetails';
import People from './lease_overview/People';
import PeopleSelector from './lease_overview/people/PeopleSelector';
import { getTranslatedString } from 'helpers/i18n';
import Documents from './lease_overview/Documents';
import { getDefaultTabSelected, getSubtitle } from './common/helpers';

const translate = (key) => getTranslatedString(`landlordPortal.applicationManagement.${key}`);

const StyledContainer = styled.div`
  padding: 0 24px;
`;

const StyledTabPane = styled(Tabs.TabPane)`
  display: flex;
  gap: 16px;

  .ant-card,
  > * {
    flex: auto;
    max-width: 100%;
  }
`;

const LeaseOverview = ({ routeParams, onChangeTab }) => {
  const currentApplication = useContext(CurrentApplicationContext);
  const [selectedApplicantId, setSelectedApplicantId] = useState(
    currentApplication.applicants[0].custom_id
  );
  const subTitle = getSubtitle(currentApplication);

  const tabList = [
    {
      key: 'overview',
      title: translate('leaseOverview.overview'),
      content: <Overview />,
    },
    {
      key: 'details',
      title: translate('leaseOverview.leaseDetails'),
      content: <LeaseDetails />,
    },
    {
      key: 'people',
      title: translate('leaseOverview.people'),
      content: <People selectedApplicantId={selectedApplicantId} />,
      side_content: (
        <PeopleSelector
          selectedApplicantId={selectedApplicantId}
          setSelectedApplicantId={setSelectedApplicantId}
        />
      ),
    },
    {
      key: 'documents',
      title: translate('leaseOverview.documents'),
      content: <Documents />,
    },
    {
      key: 'notes',
      title: translate('leaseOverview.notes'),
      content: null,
    },
    {
      key: 'history',
      title: translate('leaseOverview.history'),
      content: null,
    },
  ].filter(Boolean);

  const defaultTabSelected = getDefaultTabSelected(tabList, routeParams.tab);

  return (
    <>
      <LeaseHeader subTitle={subTitle} />
      <StyledContainer>
        <Tabs defaultActiveKey={defaultTabSelected} onChange={onChangeTab}>
          {tabList.map((tab) => (
            <React.Fragment key={tab.key}>
              <StyledTabPane tab={tab.title} key={tab.key}>
                {tab.content}
                {tab.side_content}
              </StyledTabPane>
            </React.Fragment>
          ))}
        </Tabs>
      </StyledContainer>
    </>
  );
};

export default LeaseOverview;
